import {$, PageCollection} from 'simpli-web-sdk'
import Responsavel from '@/model/resource/Responsavel'

export default class ResponsavelCollection extends PageCollection<Responsavel> {
  constructor(
    filter = {},
    endPoint: string | null = null,
    perPage: number | null = 10,
    currentPage: number | null = 0,
  ) {
    super(Responsavel, filter, perPage, currentPage)
    this.endpoint = endPoint
  }

  async listResponsavelEmbarcador(spinner = 'embarcadorResponsavel') {
    const fetch = async () => await this.GET(`/user/me/embarcador`)
    return await $.await.run(fetch, spinner)
  }
}
